import { Box, Icon, TextNew, SpacerNew } from '@jfs/ui-new'
import { Container } from '../../comps/Container'
import React, { useEffect, useCallback } from 'react'
import { AepsButton } from '../../comps/AepsButton'
import { useNavigation } from '@react-navigation/native'
import { useRoute } from '@react-navigation/core'
import { Screens } from '../../nav/Screens'
import { Image, ImageSourcePropType } from 'react-native'

export const ViewDetails = () => {
  const route = useRoute<any>()
  const navigation = useNavigation<any>()
  const { billDetails } = route.params || {}
  
  const formatDate = (dateStr: string) => {
    if (!dateStr) return 'N/A'
    const date = new Date(dateStr)
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
  }

  const product = billDetails?.order?.product || {}
  const payment = billDetails?.order?.payment || {}
  const paymentId = billDetails?.order?.payment?.id
  const paymentAt = billDetails?.order?.payment?.paymentAt
  const formattedPaymentDate = formatDate(paymentAt)
  const amount = payment?.amountDetails?.netAmount || '0.00'
  const orderId = billDetails?.order?.id
  const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
  // const BBPSAssuredLogo: ImageSourcePropType = require('../../assets/icons/BbpsAssured.svg')
      const BBPSAssuredLogo: ImageSourcePropType = require('../../assets/images/BAssuredpng.png')

  useEffect(() => {
    localStorage.removeItem('pending_order_value')
    sessionStorage.removeItem('pending_order_value')
  }, [])

  const onBackToHomeDashboard = useCallback(() => {
    navigation.navigate(Screens.BBPS_HOME_SCREEN as any)
  }, [navigation])

  return (
    <Container showFooter={false} overflow="auto" backgroundColor="BACKGROUND">
      <Box flex={1}>
        <Box width={'100%'} height={'100%'} justifyContent={'space-between'}>
          
          <Box overflow={'auto'}>
            {/* Success Header Section */}
            <Box mb={24}>
              <Box backgroundColor="WHITE" borderRadius={50}>
                <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={48} />
              </Box>
              <Box gap={4}>
                <TextNew fontSize={28} lineHeight={34} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
                  ₹ {amount}
                </TextNew>
                <TextNew fontSize={18} lineHeight={22} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
                  {product?.name || 'Bill Payment'}
                </TextNew>
                <Box flexDirection="row" alignItems={'center'} mt={4}>
                  <Icon id="CALENDAR" size={12} color="BRAND_COLOR_GRAY_1" />
                  <SpacerNew direction="horizontal" size={6} />
                  <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
                    {formattedPaymentDate}
                  </TextNew>
                </Box>
              </Box>
            </Box>

            {/* Transaction Details Card */}
            <Box
              marginBottom={20}
              customShadowStyle="shadowPrimary"
              backgroundColor="WHITE"
              padding={18}
              gap={14}
              borderRadius={16}
              borderWidth={1}
              borderColor="GREY_SEPARATOR">
              
              <Box
                flexDirection={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
                marginBottom={10}>
                <TextNew fontSize={16} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
                  {'Transaction Details'}
                </TextNew>
                 <Image source={BBPSAssuredLogo} style={{ width: 60, height: 60, resizeMode: 'contain' }} />
                {/* <Icon id={'INFO'} color="BRAND_PRIMARY_ACTION" size={24} /> */}
              </Box>

              <DetailRow label="Biller" value={product?.name || 'Bill Payment'} />
              <DetailRow label="Transaction ID" value={orderId} />
              <DetailRow label="BBPS Transaction ID" value={paymentId} />
              <DetailRow label="Payment Date" value={formattedPaymentDate} />
            </Box>

            {/* Bill Summary Card */}
            <Box
              marginBottom={20}
              customShadowStyle="shadowPrimary"
              backgroundColor="WHITE"
              padding={18}
              gap={14}
              borderRadius={16}
              borderWidth={1}
              borderColor="GREY_SEPARATOR">
              
              <DetailRow label="Bill Amount" value={`₹ ${amount}`} />
              <DetailRow label="Convenience Fee" value="₹ 0.00" />

              <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} marginVertical={8} />
              
              <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
                <TextNew fontSize={14} color="BRAND_COLOR_GRAY_2" fontWeight={'FONT_WEIGHT_BOLD'}>
                  {'Total Paid'}
                </TextNew>
                <TextNew fontSize={16} color="AVAILABLE_GREEN" fontWeight={'FONT_WEIGHT_BOLD'}>
                  ₹ {amount}
                </TextNew>
              </Box>
            </Box>
          </Box>

          {/* Footer Section */}
          <Box width={'100%'} mt={6}>
            <AepsButton
              onPress={onBackToHomeDashboard}
              title={'Done'}
              disabled={false}
            />
            <Box flexDirection="row" align="center" justify="center" 
            mt={6} 
            >
              <TextNew fontSize={11} color="BRAND_COLOR_GRAY_1" fontWeight="500">
                Powered by
              </TextNew>
              <SpacerNew direction="horizontal" size={8} />
              <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
            </Box>
          </Box>

        </Box>
      </Box>
    </Container>
  )
}

/**
 * Reusable Row Component for consistent alignment
 */
const DetailRow = ({ label, value }: { label: string; value: string | number }) => (
  <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'flex-start'}>
    <TextNew fontSize={13} color="BRAND_COLOR_GRAY_2" fontWeight={'500'} flex={1}>
      {label}
    </TextNew>
    <TextNew fontSize={13} color="BRAND_PURE_BLACK" fontWeight={'500'} flex={1.5} textAlign="right">
      {value}
    </TextNew>
  </Box>
)




// import { Box, Icon, TextNew, SpacerNew } from '@jfs/ui-new'
// import { Container } from '../../comps/Container'
// import React, { useEffect, useCallback } from 'react'
// import { AepsButton } from '../../comps/AepsButton'
// import { useNavigation } from '@react-navigation/native'
// import { useRoute } from '@react-navigation/core'
// import { Screens } from '../../nav/Screens'
// import { Image, ImageSourcePropType } from 'react-native'

// export const ViewDetails = () => {
//   const route = useRoute<any>()
//   const navigation = useNavigation<any>()
//   const { billDetails } = route.params || {}
  
//   const formatDate = (dateStr: string) => {
//     if (!dateStr) return 'N/A'
//     const date = new Date(dateStr)
//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true,
//     })
//   }

//   const product = billDetails?.order?.product || {}
//   const payment = billDetails?.order?.payment || {}
//   const paymentId = billDetails?.order?.payment?.id
//   const paymentAt = billDetails?.order?.payment?.paymentAt
//   const formattedPaymentDate = formatDate(paymentAt)
//   const amount = payment?.amountDetails?.netAmount || '0.00'
//   const orderId = billDetails?.order?.id
//   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')

//   useEffect(() => {
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onBackToHomeDashboard = useCallback(() => {
//     navigation.navigate(Screens.BBPS_HOME_SCREEN as any)
//   }, [navigation])

//   return (
//     <Container showFooter={false} overflow="auto" backgroundColor="BACKGROUND">
//       <>
//       <Box flex={1} padding={20} justifyContent="space-between">
//         <Box width={'100%'} height={'100%'} justifyContent={'space-between'}>
          
//           <Box overflow={'auto'}>
//             {/* Success Header Section */}
//             <Box mb={24}>
//               <Box backgroundColor="ALTO_DISABLED" borderRadius={50} padding={12} mb={12}>
//                 <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={40} />
//               </Box>
//               <Box gap={4}>
//                 <TextNew fontSize={28} lineHeight={34} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//                   ₹ {amount}
//                 </TextNew>
//                 <TextNew fontSize={18} lineHeight={22} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                   {product?.name || 'Bill Payment'}
//                 </TextNew>
//                 <Box flexDirection="row"  mt={4}>
//                   <Icon id="CALENDAR" size={12} color="BRAND_COLOR_GRAY_1" />
//                   <SpacerNew direction="horizontal" size={6} />
//                   <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//                     {formattedPaymentDate}
//                   </TextNew>
//                 </Box>
//               </Box>
//             </Box>

//             {/* Transaction Details Card */}
//             <Box
//               marginBottom={20}
//               customShadowStyle="shadowPrimary"
//               backgroundColor="WHITE"
//               padding={18}
//               gap={14}
//               borderRadius={16}
//               borderWidth={1}
//               borderColor="GREY_SEPARATOR">
              
//               <Box
//                 flexDirection={'row'}
//                 justifyContent={'space-between'}
//                 alignItems={'center'}
//                 marginBottom={10}>
//                 <TextNew fontSize={16} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//                   {'Transaction Details'}
//                 </TextNew>
//                 <Icon id={'INFO'} color="BRAND_PRIMARY_ACTION" size={24} />
//               </Box>

//               <DetailRow label="Biller" value={product?.name || 'Bill Payment'} />
//               <DetailRow label="Transaction ID" value={orderId} />
//               <DetailRow label="BBPS Transaction ID" value={paymentId} />
//               <DetailRow label="Payment Date" value={formattedPaymentDate} />
//             </Box>

//             {/* Bill Summary Card */}
//             <Box
//               marginBottom={20}
//               customShadowStyle="shadowPrimary"
//               backgroundColor="WHITE"
//               padding={18}
//               gap={14}
//               borderRadius={16}
//               borderWidth={1}
//               borderColor="GREY_SEPARATOR">
              
//               <DetailRow label="Bill Amount" value={`₹ ${amount}`} />
//               <DetailRow label="Convenience Fee" value="₹ 0.00" />

//               <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} marginVertical={8} />
              
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} color="BRAND_COLOR_GRAY_2" fontWeight={'FONT_WEIGHT_BOLD'}>
//                   {'Total Paid'}
//                 </TextNew>
//                 <TextNew fontSize={16} color="AVAILABLE_GREEN" fontWeight={'FONT_WEIGHT_BOLD'}>
//                   ₹ {amount}
//                 </TextNew>
//               </Box>
//             </Box>
//           </Box>

//           {/* Footer Section */}
//           <Box width={'100%'} mt={8}>
//             <AepsButton
//               onPress={onBackToHomeDashboard}
//               title={'Done'}
//               disabled={false}
//             />
//             <Box flexDirection="row" align="center" justify="center" mt={16} pb={10}>
//               <TextNew fontSize={11} color="BRAND_COLOR_GRAY_1" fontWeight="500">
//                 Powered by
//               </TextNew>
//               <SpacerNew direction="horizontal" size={8} />
//               <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
//             </Box>
//           </Box>

//         </Box>
//       </Box>
//       </>
//     </Container>
//   )
// }

// /**
//  * Reusable Row Component for consistent alignment
//  */
// const DetailRow = ({ label, value }: { label: string; value: string | number }) => (
//   <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'flex-start'}>
//     <TextNew fontSize={13} color="BRAND_COLOR_GRAY_2" fontWeight={'500'} flex={1}>
//       {label}
//     </TextNew>
//     <TextNew fontSize={13} color="BRAND_PURE_BLACK" fontWeight={'500'} flex={1.5} textAlign="right">
//       {value}
//     </TextNew>
//   </Box>
// )

// import { Box, Icon, TextNew, SpacerNew } from '@jfs/ui-new'
// import { Container } from '../../comps/Container'
// import React, { useState, useEffect, useCallback } from 'react'
// import { AepsButton } from '../../comps/AepsButton'
// import { useNavigation } from '@react-navigation/native'
// import { useRoute } from '@react-navigation/core'
// import { Screens } from '../../nav/Screens'
// import { Image, ImageSourcePropType } from 'react-native'

// export const ViewDetails = () => {
//   const route = useRoute<any>()
//   const navigation = useNavigation<any>()
//   const { billDetails } = route.params || {}
  
//   const formatDate = (dateStr: string) => {
//     if (!dateStr) return 'N/A'
//     const date = new Date(dateStr)
//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true,
//     })
//   }

//   const product = billDetails?.order?.product || {}
//   const payment = billDetails?.order?.payment || {}
//   const paymentId = billDetails?.order?.payment?.id
//   const paymentAt = billDetails?.order?.payment?.paymentAt
//   const formattedPaymentDate = formatDate(paymentAt)
//   const amount = payment?.amountDetails?.netAmount || '0.00'
//   const orderId = billDetails?.order?.id
//   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')

//   useEffect(() => {
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onBackToHomeDashboard = useCallback(() => {
//     navigation.navigate(Screens.BBPS_HOME_SCREEN as any)
//   }, [navigation])

//   return (
//     <Container showFooter={false} overflow="auto" backgroundColor="BACKGROUND">
//       <Box padding={20} flex={1}>
        
//         {/* Header Section: Status & Main Info */}
//         <Box alignItems="center" mb={24}>
//           <Box backgroundColor="DISMANTLED_GREEN" borderRadius={50} padding={12} mb={16}>
//              <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={48} />
//           </Box>
//           <TextNew fontSize={28} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//             ₹ {amount}
//           </TextNew>
//           <TextNew fontSize={18} color="DARK_GREY" fontWeight={'500'}>
//             {product?.name || 'Bill Payment'}
//           </TextNew>
          
//           <Box flexDirection="row" alignItems="center" mt={8} backgroundColor="WHITE" paddingHorizontal={12} paddingVertical={4} borderRadius={20} borderWidth={1} borderColor="BORDER_COLOR">
//             <Icon id="CALENDAR" size={12} color="PRIMARY_GREY" />
//             <SpacerNew direction="horizontal" size={6} />
//             <TextNew fontSize={12} color="PRIMARY_GREY" fontWeight="500">
//               {formattedPaymentDate}
//             </TextNew>
//           </Box>
//         </Box>

//         {/* Transaction Details Card */}
//         <Box
//           backgroundColor="WHITE"
//           padding={20}
//           mb={20}
//           borderRadius={16}
//           borderWidth={1}
//           borderColor="GREY_SEPARATOR"
//           customShadowStyle="shadowPrimary">
          
//           <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} mb={20}>
//             <TextNew fontSize={16} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//               {'Transaction Details'}
//             </TextNew>
//             <Icon id={'INFO'} color="PRIMARY" size={24} />
//           </Box>

//           <DetailRow label="Biller" value={product?.name || 'Bill Payment'} />
//           <DetailRow label="Transaction ID" value={orderId} />
//           <DetailRow label="BBPS Ref ID" value={paymentId} />
//           <DetailRow label="Payment Date" value={formattedPaymentDate} isLast />
//         </Box>

//         {/* Payment Summary Card */}
//         <Box
//           backgroundColor="WHITE"
//           padding={20}
//           mb={30}
//           borderRadius={16}
//           borderWidth={1}
//           borderColor="GREY_SEPARATOR"
//           customShadowStyle="shadowPrimary">
          
//           <DetailRow label="Bill Amount" value={`₹ ${amount}`} />
//           <DetailRow label="Convenience Fee" value="₹ 0.00" />
          
//           <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'GREY_SEPARATOR'} width={'100%'}  />
          
//           <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//             <TextNew fontSize={16} color="BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//               {'Total Paid'}
//             </TextNew>
//             <TextNew fontSize={18} color="AVAILABLE_GREEN" fontWeight={'FONT_WEIGHT_BOLD'}>
//               ₹ {amount}
//             </TextNew>
//           </Box>
//         </Box>

//         {/* Footer Actions */}
//         <Box width={'100%'} mt="auto">
//           <AepsButton
//             onPress={onBackToHomeDashboard}
//             title={'Done'}
//             disabled={false}
//           />
//           <Box flexDirection="row" align="center" justify="center" mt={20} pb={10}>
//             <TextNew fontSize={12} color="TINY_GREY" fontWeight="500">
//               Powered by
//             </TextNew>
//             <SpacerNew direction="horizontal" size={8} />
//             <Image source={BBPSLogo} style={{ width: 70, height: 20, resizeMode: 'contain' }} />
//           </Box>
//         </Box>

//       </Box>
//     </Container>
//   )
// }

// /**
//  * Reusable Row Component for clean code and consistent spacing
//  */
// const DetailRow = ({ label, value, isLast = false }: { label: string, value: any, isLast?: boolean }) => (
//   <Box 
//     justifyContent={'space-between'} 
//     flexDirection={'row'} 
//     alignItems={'flex-start'} 
//     mb={isLast ? 0 : 16}
//   >
//     <TextNew fontSize={13} color="PRIMARY_GREY" fontWeight={'500'} flex={1}>
//       {label}
//     </TextNew>
//     <TextNew fontSize={13} color="BLACK" fontWeight={'500'} flex={1.5} textAlign="right">
//       {value || 'N/A'}
//     </TextNew>
//   </Box>
// )

// import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
// import { Container } from '../../comps/Container'
// import React, { useState, useEffect, useCallback } from 'react'
// import { InactivityDialog } from '../../comps/InactivityDialog'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { ServiceHighlights } from '../../comps/ServiceHighlight'
// import { IconWithText } from '../../comps/IconWithText'
// import { AepsCheckBox } from '../../comps/AepsCheckBox'
// import { AepsButton } from '../../comps/AepsButton'
// import { flex } from 'styled-system'
// import { RowItem } from '../../comps/RowItem'
// import { useNavigation } from '@react-navigation/native'
// import { useRoute } from '@react-navigation/core'
// import { Screens } from '../../nav/Screens'
// import { BackHandler, Platform, StyleSheet, View, Image, ImageSourcePropType } from 'react-native'

// export const ViewDetails = () => {
//   const route = useRoute<any>() // Access route params
//   const navigation = useNavigation<any>()
//   const { billDetails } = route.params || {}
//   const order = billDetails?.order || {}

//   const formatDate = (dateStr: string) => {
//     if (!dateStr) return 'N/A'
//     const date = new Date(dateStr)
//     // use toLocaleString instead of toLocaleDateString
//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true, // Forces AM/PM format
//     })
//   }
//   const bill = billDetails?.bill
//   const product = billDetails?.order?.product || {}
//   const payment = billDetails?.order?.payment || {}
//   const paymentId = billDetails?.order?.payment?.id
//   const paymentAt = billDetails?.order?.payment?.paymentAt
//   const formattedPaymentDate = formatDate(paymentAt)
//   const transactionData = billDetails?.order || {}
//   const paymentInfo = transactionData?.payment || {}
//   const productInfo = transactionData?.product || {}
//   //   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')
//   const amount = payment?.amountDetails?.netAmount || '0.00'
//   const orderId = billDetails?.order.id

//   const [showInactivityDialog, setShowInactivityDialog] = useState(false)

//   useEffect(() => {
//     // Clear sensitive polling data
//     localStorage.removeItem('pending_order_value')
//     sessionStorage.removeItem('pending_order_value')
//   }, [])

//   const onBackToHomeDashboard = useCallback(() => {
//     navigation.navigate(Screens.BBPS_HOME_SCREEN as any)
//   }, [navigation])

//   const onDonePress = () => {
//     // navigation.popToTop()
//     navigation.reset({
//       index: 0,
//       routes: [{ name: Screens.BBPS_HOME_SCREEN as any }],
//     })
//   }
//   const BBPSLogo: ImageSourcePropType = require('../../assets/images/BBPSLogo.png')

//   // const handleInactivityDialogPress = () => {
//   //     setShowInactivityDialog(false);
//   // };

//   // useEffect(() => {
//   //     fetchFavourites()
//   //     fetchRecentPayments()
//   // }, [])

//   const searchList = (tnxId) => {
//     console.log(tnxId)
//   }

//   const handlePress = () => {
//     setShowInactivityDialog(true)
//     console.log('enter something here.')
//   }

//   // const onPrimaryButtonPress = () => {
//   //     setOpenConfirmDialog(true)
//   // }

//   return (
//     <Container showFooter={true} overflow="auto">
//       <>
//         <Box overflow={'auto'}>
//           <Box width={'100%'} justifyContent={'space-between'} height={'100%'}>
//             <Box marginBottom={10}>
//               <Icon id={'STATUS_SUCCESS'} color="AVAILABLE_GREEN" size={40} />
//             </Box>
//             <Box gap={10}>
//               <TextNew fontSize={24} lineHeight={28} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//                 ₹ {payment?.amountDetails?.netAmount || '300'}
//               </TextNew>
//               <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                 {product?.name || 'Bill Payment'}
//                 {/* {"Mobile Recharge Bill Payments"} */}
//               </TextNew>
//               <Box flexDirection="row" alignItems="center">
//                 <Icon id="CALENDAR" size={14} color="BRAND_COLOR_GRAY_1" />
//                 <SpacerNew direction="horizontal" size={6} />
//                 <TextNew fontSize={13} color="BRAND_COLOR_GRAY_1">
//                   {formattedPaymentDate}
//                 </TextNew>
//               </Box>
              
//             </Box>
//             <Box
//               marginBottom={20}
//               marginTop={20}
//               customShadowStyle="shadowPrimary"
//               padding={15}
//               gap={12}
//               borderRadius={15}>
//               <Box
//                 flexDirection={'row'}
//                 justifyContent={'space-between'}
//                 alignItems={'center'}
//                 shadowColor={'BLACK_GRAY_SHADE'}
//                 marginBottom={20}>
//                 <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                   {'Transaction Details'}
//                 </TextNew>
//                 <Icon id={'INFO'} color="BRAND_PRIMARY_ACTION" size={30} />
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Biller'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {product?.name || 'Bill Payment'}
//                 </TextNew>
//               </Box>
//               {/* <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"Utr Number"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"139786275"}
//                             </TextNew>
//                         </Box> */}
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {orderId}
//                   {/* {paymentId || ""} */}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'BBPS Transaction ID'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {paymentId}
//                   {/* {order.id} */}
//                   {/* {"JIO14057000000002H386"} */}
//                 </TextNew>
//               </Box>
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Payment Date'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   {formattedPaymentDate}
//                   {/* {order.id} */}
//                   {/* {"JIO14057000000002H386"} */}
//                 </TextNew>
//               </Box>
//               {/* <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"Paid by"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"UPI"}
//                             </TextNew>
//                         </Box> */}
//             </Box>










//             <Box
//               marginBottom={20}
//               marginTop={20}
//               customShadowStyle="shadowPrimary"
//               padding={15}
//               gap={12}
//               borderRadius={15}>
              
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Bill Amount'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                    ₹ {amount || '0.00'}
//                 </TextNew>
//               </Box>
//               {/* <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"Utr Number"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"139786275"}
//                             </TextNew>
//                         </Box> */}
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Convenience Fee'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                    ₹ 0.00
//                   {/* {paymentId || ""} */}
//                 </TextNew>
//               </Box>

//               <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
              
//               <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                 <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                   {'Total'}
//                 </TextNew>
//                 <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                   ₹ {amount || '0.00'}
//                 </TextNew>
//               </Box>
              
//             </Box>

//           </Box>
//         </Box>

//         {/* <Box flexDirection={'row'} justifyContent={'space-between'} marginBottom={20} marginTop={20} customShadowStyle='shadowPrimary' padding={15} gap={12} borderRadius={15}>
//                         <TextNew fontSize={14} lineHeight={20} fontWeight={'FONT_WEIGHT_BOLD'}>
//                             {"Need help"}
//                         </TextNew>
//                         <TextNew fontSize={14} lineHeight={20} fontWeight={'FONT_WEIGHT_BOLD'}>
//                             {">"}
//                         </TextNew>
//                     </Box> */}

//         <Box width={'100%'}>
//           <AepsButton
//             onPress={onBackToHomeDashboard}
//             title={'Done'}
//             disabled={false}
//             // iconId={status == 'LINKED' ? 'FINGERPRINT' : undefined}
//           />
//           <Box flexDirection="row" align="center" justify="center">
//             <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//               Powered by
//             </TextNew>
//             <SpacerNew direction="horizontal" size={8} />
//             <Image source={BBPSLogo} style={{ width: 80, height: 24, resizeMode: 'contain' }} />
//           </Box>
//         </Box>
//       </>
//     </Container>
//   )
// }

// import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
// import { Container } from '../../comps/Container'
// import React, { useState, useEffect } from 'react'
// import { InactivityDialog } from '../../comps/InactivityDialog'
// import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
// import { ServiceHighlights } from '../../comps/ServiceHighlight'
// import { IconWithText } from '../../comps/IconWithText'
// import { AepsCheckBox } from '../../comps/AepsCheckBox'
// import { AepsButton } from '../../comps/AepsButton'
// import { flex } from 'styled-system'
// import { RowItem } from '../../comps/RowItem'
// import { useNavigation } from '@react-navigation/native'
// import { useRoute } from '@react-navigation/core'
// import { Screens } from '../../nav/Screens'

// // Mock data and functions to simulate a dynamic component
// const useLazyApiData = (apiFn) => {
//     const [data, setData] = useState(null)
//     const [loading, setLoading] = useState(false)
//     const [error, setError] = useState(null)

//     const callApi = async () => {
//         setLoading(true)
//         setError(null)
//         try {
//             // Simulate an API call with a delay
//             const mockData = await new Promise(resolve => setTimeout(() => {
//                 // Mock data based on the section
//                 if (apiFn.name === 'fetchFavourites') {
//                     resolve([
//                         { id: '1', name: 'ICICI Bank FASTag', customerName: 'Prakash', vehicleNo: 'MH034589', lastLinked: 'O5 june 2025' },
//                         { id: '2', name: 'Airtel Postpaid', customerName: 'Rahul', mobileNo: '9876543210', lastLinked: '10 July 2025' }
//                     ])
//                 } else if (apiFn.name === 'fetchRecentPayments') {
//                     resolve([
//                         { id: '3', name: 'BSES Rajdhani', customerName: 'Anil', accountNo: '12345678', lastLinked: '22 May 2025' },
//                         { id: '4', name: 'JioFiber', customerName: 'Priya', accountNo: '87654321', lastLinked: '01 June 2025' }
//                     ])
//                 } else {
//                     resolve([])
//                 }
//             }, 1000))
//             setData(mockData)
//         } catch (err) {
//             setError(err)
//         } finally {
//             setLoading(false)
//         }
//     }

//     return [data, callApi, loading, error]
// }

// const mockFetchFavourites = () => { /* This function is just a placeholder to be used by the hook */ }
// const mockFetchRecentPayments = () => { /* This function is just a placeholder to be used by the hook */ }

// const staticData = [
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
//     {
//         initials: "RJ",
//         name: "Riya Jain",
//         phoneNumber: "9876543210"
//     },
// ]

// export const ViewDetails = () => {

//     const route = useRoute<any>(); // Access route params
//     const navigation = useNavigation<any>();
// const { billDetails } = route.params || {};
//     const order = billDetails?.order;
//     const product = order?.product;
//     const payment = order?.payment;

//     const [favourites, fetchFavourites, favouritesLoading] = useLazyApiData(mockFetchFavourites)
//     const [recentPayments, fetchRecentPayments, paymentsLoading] = useLazyApiData(mockFetchRecentPayments)
//     const [activeTab, setActiveTab] = useState('payBills')
//     const [showInactivityDialog, setShowInactivityDialog] = useState(false);
//     const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
//     const [checked, setChecked] = useState(false)
//     const routes = useRoute()
//     const handleInactivityDialogPress = () => {
//         setShowInactivityDialog(false);
//     };

//     useEffect(() => {
//         fetchFavourites()
//         fetchRecentPayments()
//     }, [])

//         useEffect(() => {
//             // 2. Clear sensitive polling data from storage once we hit this terminal screen
//             localStorage.removeItem('pending_order_value');
//             sessionStorage.removeItem('pending_order_value');
//         }, [])

//     const searchList = (tnxId) => {
//         console.log(tnxId)
//     }

//     const handlePress = () => {
//         setShowInactivityDialog(true)
//         console.log("enter something here.")
//     }

//     const onPrimaryButtonPress = () => {
//         setOpenConfirmDialog(true)
//     }

//     return (
//         <Container showFooter={true} overflow='auto'>
//             <>
//                 <Box width={'100%'} justifyContent={'space-between'} height={'100%'} >
//                     <Box marginBottom={10}>
//                         <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} />
//                     </Box>
//                     <Box gap={10}>
//                         <TextNew fontSize={24} lineHeight={28} color="BRAND_PURE_BLACK" fontWeight={'FONT_WEIGHT_BOLD'}>
//                             {"300.000"}
//                         </TextNew>
//                         <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                             {"Mobile Recharge Bill Payments"}
//                         </TextNew>
//                         <TextNew fontSize={12} lineHeight={18} color="BRAND_COLOR_GRAY_1">
//                             {"26 Feb 2024, 05:44 PM"}
//                         </TextNew>
//                     </Box>
//                     <Box marginBottom={20} marginTop={20} customShadowStyle='shadowPrimary' padding={15} gap={12} borderRadius={15}>
//                         <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} shadowColor={'BLACK_GRAY_SHADE'} marginBottom={20}>
//                             <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                                 {"Transaction Details"}
//                             </TextNew>
//                             <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} />
//                         </Box>
//                         <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"Biller"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"Mobile Recharge Bill Payments"}
//                             </TextNew>
//                         </Box>
//                         <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"Utr Number"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"139786275"}
//                             </TextNew>
//                         </Box>
//                         <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"Transaction ID"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"TXN4057044156566"}
//                             </TextNew>
//                         </Box>
//                         <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"BBPS Transaction ID"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"JIO14057000000002H386"}
//                             </TextNew>
//                         </Box>
//                         <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"Paid by"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"UPI"}
//                             </TextNew>
//                         </Box>
//                     </Box>
//                     <Box marginBottom={20} marginTop={20} customShadowStyle='shadowPrimary' padding={15} gap={12} borderRadius={15}>
//                         <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} shadowColor={'BLACK_GRAY_SHADE'} marginBottom={20}>
//                             <TextNew fontSize={18} lineHeight={20} color="BRAND_COLOR_GRAY_1" fontWeight={'500'}>
//                                 {"Transaction Details"}
//                             </TextNew>
//                             {/* <Icon id={'SUCCESSFUL_EMPTY'} color="AVAILABLE_GREEN" size={30} /> */}
//                         </Box>
//                         <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"Biller"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"Mobile Recharge Bill Payments"}
//                             </TextNew>
//                         </Box>

//                         <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"Transaction ID"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"TXN4057044156566"}
//                             </TextNew>
//                         </Box>
//                         <Box borderStyle={'dashed'} borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} />
//                         <Box justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
//                             <TextNew fontSize={14} lineHeight={20} color="BRAND_COLOR_GRAY_2" fontWeight={'500'}>
//                                 {"BBPS Transaction ID"}
//                             </TextNew>
//                             <TextNew fontSize={14} lineHeight={20} fontWeight={'500'}>
//                                 {"JIO14057000000002H386"}
//                             </TextNew>
//                         </Box>
//                     </Box>
//                     <Box flexDirection={'row'} justifyContent={'space-between'} marginBottom={20} marginTop={20} customShadowStyle='shadowPrimary' padding={15} gap={12} borderRadius={15}>
//                         <TextNew fontSize={14} lineHeight={20} fontWeight={'FONT_WEIGHT_BOLD'}>
//                             {"Need help"}
//                         </TextNew>
//                         <TextNew fontSize={14} lineHeight={20} fontWeight={'FONT_WEIGHT_BOLD'}>
//                             {">"}
//                         </TextNew>
//                     </Box>
//                 </Box>
//                 {/* <Box width={'100%'}>
//                     <AepsButton
//                         onPress={onPrimaryButtonPress}
//                         title={'Register Now'}
//                         disabled={false}

//                     // iconId={status == 'LINKED' ? 'FINGERPRINT' : undefined}
//                     />
//                 </Box> */}
//             </>
//         </Container>
//     )
// }
